var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "solid",
    height: 512,
    viewBox: "0 0 16 16",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 4c0-2.209-1.791-4-4-4s-4 1.791-4 4c0 2.038 1.53 3.701 3.5 3.95v7.55c0 .276.224.5.5.5s.5-.224.5-.5v-7.55c1.97-.249 3.5-1.912 3.5-3.95zm-4-2c-1.103 0-2 .897-2 2 0 .276-.224.5-.5.5s-.5-.224-.5-.5c0-1.654 1.346-3 3-3 .276 0 .5.224.5.5s-.224.5-.5.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/PIN.df2f870b2f9fd05a36cae9c508fb6974.svg";
export { ForwardRef as ReactComponent };